export const HeaderBottomMain = [
  "Brand",
  "Beauty",
  "Women",
  "Man",
  "Bag",
  "Shoes",
  "Accessories",
  "Sports/Leisure",
  "Golf",
  "Kids",
  "Life",
];

export const HeaderBottomSide = ["NewBrand", "이벤트", "아울렛"];

export const mobileHeaderNav = ["Home", "Event", "Deak", "Best"];

export const footerCustomerMenu = ["고객센터", "공지사항", "카톡상담", "ARS"];
export const footerBootomMockData = [
  "ABOUT",
  "회사소개",
  "매장안내",
  "입점상담",
  "개인정보처리방침",
  "이용약관",
];
